module.exports = __webpack_public_path__ + "static/img/personalMailTip1.ceb2c23a.png";